import auth from '@common/auth/auth';
import { AppGlobal } from '@common/constants/constants';
import { localStorageService } from '@common/storage';
const FEATURE_FLAGS_LOCAL_STORAGE_KEY = `FEATURE_FLAGS_${AppGlobal.BUILD_NUMBER}`;
class ServerConfig {
    constructor() {
        const featureFlags = localStorageService.get(FEATURE_FLAGS_LOCAL_STORAGE_KEY);
        if (featureFlags) {
            this.featureFlagsMap = featureFlags.split('|').reduce((acc, it) => {
                acc[it] = true;
                return acc;
            }, {});
        }
    }
    initialize({ config, featureFlagsMap }) {
        this.config = config || this.config;
        this.featureFlagsMap = featureFlagsMap || this.featureFlagsMap;
        if (featureFlagsMap) {
            localStorageService.set(FEATURE_FLAGS_LOCAL_STORAGE_KEY, Object.keys(featureFlagsMap)
                .filter(it => featureFlagsMap[it])
                .join('|'));
        }
        return this;
    }
    isInitialized() {
        return !!this.config && !!this.featureFlagsMap;
    }
    getAvailableUpdates() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.availableUpdate;
    }
    isOfflineMode() {
        return this.authFeatureTogglesCheck('offlineModeEnabled');
    }
    hasIdpIntegration() {
        return this.authFeatureTogglesCheck('idpImportEnabled');
    }
    hasFeatureFlagsManagementEnabled() {
        var _a, _b;
        return !!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.featureToggles) === null || _b === void 0 ? void 0 : _b.featureFlagsPage);
    }
    hasSamlSupport() {
        return this.authFeatureTogglesCheck('enableSaml');
    }
    isCloud() {
        return this.authFeatureTogglesCheck('cloudModeEnabled');
    }
    isSwaggerEnabled() {
        return this.authFeatureTogglesCheck('swaggerEnabled');
    }
    isAnalyticsEnabled() {
        return this.authFeatureTogglesCheck('analyticsEnabled');
    }
    isUserActivityAnalyticsEnabled() {
        return this.authFeatureTogglesCheck('enableUserActivityAnalytics');
    }
    hasFeature(key) {
        if (this.featureFlagsMap && this.featureFlagsMap[key] !== undefined) {
            return this.featureFlagsMap[key];
        }
        return this.authFeatureTogglesCheck(key);
    }
    authFeatureTogglesCheck(key) {
        return auth.isAuthenticated() ? auth.getFeatures()[key] === true : false;
    }
}
export default new ServerConfig();
